import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root',
})
export class ApiService {
    baseUrl = environment.baseUrl;

    constructor(private http: HttpClient) {}

    get(endpoint: string, params?: any, options?: any) {
        return this.http.get(this.baseUrl + endpoint, options);
    }

    post(endpoint: string, params?: any, options?: any) {
        return this.http.post(this.baseUrl + endpoint, params, options);
    }

    postPhp(endpoint: string, params: any, options?: any) {
        return this.http.post(
            'https://php.pave.com.my/dev/' + endpoint,
            params,
            options
        );
    }

    patch(endpoint: string, params: any, options?: any) {
        return this.http.patch(this.baseUrl + endpoint, params, options);
    }

    download(endpoint: string, params: any, options?: any) {
        const initialOptions = {
            responseType: 'blob',
        };
        
        options = options || initialOptions;
        return this.http.post(this.baseUrl + endpoint, params, options);
    }

    put(endpoint: string, params: any, options?: any) {
        return this.http.put(this.baseUrl + endpoint, params, options);
    }

    getDocument(endpoint: string, params?: any, options?: any) {
        const initialOptions = {
            responseType: 'blob',
        };
        
        options = options || initialOptions;
        return this.http.get(this.baseUrl + endpoint, options);
    }
}
